import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardBody,
  VStack,
  Text,
} from '@chakra-ui/react';
import { useAuth } from '../context/AuthContext';
import BundlingProductTab from '../components/BundlingProductTab';
import GoersManualPool from '../components/GoersManualPool';
import IeemWorkspaceTabs from '../components/IeemWorkspaceTabs';
import EmptyStateBlock from '../components/bundling/EmptyStateBlock';
import PageHeader from '../components/bundling/PageHeader';

const TourismDevelopment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedRole, user } = useAuth();
  
  // Determine active tab based on route - hanya untuk IEEM sub menu
  const isIeemRoute = location.pathname.includes('/tourism-development/ieem') || location.pathname === '/admin/tourism-development/ieem';
  const isBundlingProductRoute = location.pathname.includes('/tourism-development/bundling-product') || location.pathname === '/admin/tourism-development/bundling-product';
  
  // Tab hanya untuk IEEM: How to Publish dan List Product
  const [activeIeemTab, setActiveIeemTab] = useState(0);
  
  // Update active tab when route changes
  useEffect(() => {
    if (location.pathname === '/admin/tourism-development/ieem' || location.pathname === '/admin/tourism-development') {
      // Default redirect to IEEM if no sub route specified
      navigate('/admin/tourism-development/ieem', { replace: true });
    }
  }, [location.pathname, navigate]);

  // Check user role
  const userRole = user?.role || '';
  let parsedUserRoles = [];
  if (userRole) {
    if (Array.isArray(userRole)) {
      parsedUserRoles = userRole;
    } else if (typeof userRole === 'string') {
      if (userRole.includes(';')) {
        parsedUserRoles = userRole.split(';').map(r => r.trim()).filter(r => r);
      } else if (userRole.includes(',')) {
        parsedUserRoles = userRole.split(',').map(r => r.trim()).filter(r => r);
      } else if (userRole.trim()) {
        parsedUserRoles = [userRole.trim()];
      }
    }
  }
  
  const hasRoleIeem = selectedRole === 'ieem' || (!selectedRole && parsedUserRoles.includes('ieem'));
  const hasRoleBp = selectedRole === 'bp' || (!selectedRole && parsedUserRoles.includes('bp'));

  // Mapping IEMMPUBLISH_MEMBER
  const getMemberCode = () => 'itdc';

  const eyebrow = isIeemRoute ? 'IEEM Workspace' : isBundlingProductRoute ? 'Product Workspace' : 'Domain Workspace';

  return (
    <Box>
      <VStack align="stretch" spacing={4} mb={6}>
        <PageHeader
          eyebrow={eyebrow}
          title="Injourney Tourism Development"
          description="Kelola channel publishing IEEM dan bundling product untuk Injourney Tourism Development."
        />
      </VStack>

      <Card bg="white" borderRadius="16px" boxShadow="sm">
        <CardBody p={{ base: 2, lg: 4 }}>
          {/* Hanya tampilkan tab jika di route IEEM */}
          {isIeemRoute && hasRoleIeem ? (
            <IeemWorkspaceTabs
              activeIeemTab={activeIeemTab}
              onTabChange={setActiveIeemTab}
              memberCode={getMemberCode()}
              productsContent={
                <EmptyStateBlock
                  title="Products workspace akan segera tersedia"
                  description="Daftar product readiness untuk InJourney Tourism Development akan ditampilkan di sini."
                />
              }
              analyticsContent={
                <EmptyStateBlock
                  title="Analytics workspace belum tersedia"
                  description="Summary analytics dan exception readiness Tourism Development akan muncul setelah data source terhubung."
                />
              }
            />
          ) : isBundlingProductRoute && hasRoleBp ? (
            // Bundling Product route — event ticket pool sits above the product list
            // because the [GOERS:<id>] tag it shows is what the product name must carry.
            <>
              <GoersManualPool memberId={getMemberCode()} />
              <BundlingProductTab memberId={getMemberCode()} />
            </>
          ) : (
            // Default - redirect ke IEEM
            <VStack align="stretch" spacing={4}>
              <Text color="gray.600">
                Memuat...
              </Text>
            </VStack>
          )}
        </CardBody>
      </Card>
    </Box>
  );
};

export default TourismDevelopment;
